<template>
  <div>
    <h2 class="section-title">{{ title }}</h2>

    <div class="table-scroll">
      <AppTable>
        <thead>
          <tr>
            <th>Gäller fr.o.m.</th>
            <th>3 mån</th>
            <th>1 år</th>
            <th>2 år</th>
            <th>3 år</th>
            <th>4 år</th>
            <th>5 år</th>
            <th>7 år</th>
            <th>10 år</th>
            <th>Handpenning- &amp; brygglån</th>
          </tr>
        </thead>
        <tbody>
          <AppTableRow v-for="(rate, index) in rates" :key="index">
            <AppTableCell>{{ formatDateIfValid(rate.validFrom) ?? '-' }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.threeMonth) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.oneYear) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.twoYear) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.threeYear) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.fourYear) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.fiveYear) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.sevenYear) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.tenYear) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(rate.sixMonth) }}</AppTableCell>
          </AppTableRow>
          <AppTableRow v-if="!rates.length">
            <AppTableCell colspan="10" class="text-center" :class="{ 'error-text': fetchRatesError }">
              {{ emptyStateText }}
            </AppTableCell>
          </AppTableRow>
        </tbody>
      </AppTable>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { AppTable, AppTableRow, AppTableCell } from '@staff/ui'
import { formatDateIfValid, formatPercentage } from '@staff/shared'

import { usePricing } from '@/composables/usePricing'
import type { Rate } from '@/services/rates'

const props = defineProps<{
  title: string
  rates: Rate[]
  emptyText: string
}>()

const { isFetchingRates, fetchRatesError } = usePricing()

const emptyStateText = computed(() => {
  if (isFetchingRates.value) return 'Hämtar räntor...'
  if (fetchRatesError.value) return `Kunde inte hämta räntor: ${fetchRatesError.value.message}`
  return props.emptyText
})
</script>

<style scoped lang="scss">
.section-title {
  margin-bottom: 16px;
}

.table-scroll {
  max-height: 400px;
  overflow-y: auto;
}
</style>
